export const toCamelCaseObject = (obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    acc[key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())] =
      obj[key];
    return acc;
  }, {});
};
